<template>
  <div />
</template>

<script>
export default {
  name:"CallStore",
  data () { return {
    calls: [],
    callTakers: {},
    showCalls: false,
    showDebugCalls: false,
    limit: 1000,
    url: '',
  }},
  mounted: async function(){
    this.url = `https://fandango-wombat-7897.twil.io/logging_calls?k=${this.$_auid}`
    this.loadData();
  },
  destroyed(){

  },
  methods: {
    // loadData: async function(){
    //   const r = await axios.get(`${this.url}&m=list&limit=${this.limit}`)
    //   this.calls = r.data;
    // },
    loadData: async function(pageNumber=0, pageToken=''){
      //this uses m=pageList and loops through it to get all the calls
      const r = await axios.get(`${this.url}&m=pageList&pageNumber=${[pageNumber]}&pageToken=${pageToken}`)
      this.calls = [...this.calls, ...r.data.instances];
      // console.log('DEBUG', r.data.instances.length, pageNumber)

      if(r.data.instances.length && r.data.nextPageUrl){
        const pageToken = r.data.nextPageUrl.match(/PageToken=([^&]*)/)[1];
        this.loadData(pageNumber+1, pageToken)
      }
    },
    numberOfCalls: (calls, key) => calls.filter(r=>r.status===key).length,
    callsForKey: (calls, key) => calls.filter(r=>r.status===key),
  },

  computed: {
    toCalls: function(){
      let result = []
      if(this.calls.length === 0)
        return result;
      this.calls.filter(r=>r.direction==="outbound-dial").forEach(call=>{
        !result[call.to] ? result[call.to] = [] : 1+1;
        result[call.to].push(call);
      })
      result.totalBusy = this.calls.filter(r=>r.direction==="inbound" && r.status==="busy")
      // result.distinctBusy = [...new Set(result.totalBusy)];
      result = this.$util.objectToArray(result, 'callTaker', 'calls')
      result = this.$util.sortDescForKeyPath(result, 'calls.length');
      return result;
    },

    fromCalls: function(){
      let result = []
      if(this.calls.length === 0)
        return result;
      this.calls.filter(r=>r.direction==="outbound-dial").forEach(call=>{
        !result[call.from] ? result[call.from] = [] : 1+1;
        result[call.from].push(call);
      })
      result = this.$util.objectToArray(result, 'phoneFrom', 'calls')
      result = this.$util.sortDescForKeyPath(result, 'calls.length');
      console.log(result);
      return result;
    },
  }
}
</script>